import {safeUnreachableCase} from '~/utils/unreachableCase'
import HgArticleHeroHighHorizontal, {
  type HgArticleHeroHighHorizontalProps,
} from './HgArticleHeroHighHorizontal'
import HgArticleHeroHighVertical, {
  type HgArticleHeroHighVerticalProps,
} from './HgArticleHeroHighVertical'
import HgArticleHeroNoAsset, {
  type HgArticleHeroNoAssetProps,
} from '../HgArticleHeroNoAsset'

type HgArticleHeroVariantProps =
  | HgArticleHeroHighHorizontalProps
  | HgArticleHeroHighVerticalProps
  | HgArticleHeroNoAssetProps

export type HgArticleHeroHighProps = {
  level: 'high'
  className?: string
} & HgArticleHeroVariantProps

export function HgArticleHeroHigh(props: HgArticleHeroHighProps) {
  switch (props.assetType) {
    case 'horizontal':
      return <HgArticleHeroHighHorizontal {...props} />
    case 'vertical':
      return <HgArticleHeroHighVertical {...props} />
    case 'none':
      return <HgArticleHeroNoAsset {...props} />
    default:
      return safeUnreachableCase(props, null)
  }
}
